import React from "react"

type ActiveKey = "green" | "black" | "section4"

interface TeaVerticalNavProps {
  active: ActiveKey
  onChange: (key: ActiveKey) => void
}

const teaItems = [
  {
    key: "green" as ActiveKey,
    label: "Trà Lài Xanh",
    icon: "./logos/leaf-icon.png",
  },
  {
    key: "black" as ActiveKey,
    label: "Trà Đen",
    icon: "./logos/leaf-default.png",
  },
  {
    key: "section4" as ActiveKey,
    label: "Hướng dẫn",
    icon: "./logos/cup-of-tea.png",
  },
]

const TeaVerticalNav: React.FC<TeaVerticalNavProps> = ({
  active,
  onChange,
}) => {
  return (
    <div className="absolute left-[10%] z-30 h-full flex flex-col items-center justify-center">
      {/* Rope background */}
      <img
        src="./rope.png"
        alt="rope"
        className="absolute h-full w-[10px] object-cover top-0 left-1/2 transform -translate-x-1/2 z-10"
      />

      <div className="relative flex flex-col items-center justify-center h-full">
        {teaItems.map((item, idx) => (
          <div
            key={item.key}
            className={`relative w-[172px] h-[172px] flex items-center justify-center ${
              idx === 0 ? "mb-8" : idx === teaItems.length - 1 ? "mt-8" : "my-8"
            }`}
          >
            {/* Flower Ring (active effect) */}
            {active === item.key && (
              <img
                src="./flower-ring.png"
                alt="active"
                className="absolute inset-0 object-contain pointer-events-none z-[30]"
              />
            )}

            {/* Button */}
            <button
              onClick={() => onChange(item.key)}
              className="relative z-20 w-[150px] h-[150px] flex flex-col items-center justify-center transition-all group"
            >
              <img
                src="./wood-circle.png"
                alt="wood"
                className="absolute w-full h-full object-contain transition-transform duration-300 group-hover:scale-105"
              />

              <span
                className={`relative z-20 text-lg font-playfair font-bold text-[#092b16] transition-colors duration-200 ${
                  active === item.key ? "text-gray-800" : ""
                }`}
              >
                {item.label}
              </span>

              <img
                src={item.icon}
                alt="icon"
                className="absolute bottom-6 z-20 w-8 h-8 transition-transform duration-300 group-hover:translate-y-[-2px]"
              />
            </button>
          </div>
        ))}
      </div>
    </div>
  )
}

export default TeaVerticalNav
